import React from 'react';
import { Box, List, ListItem, Heading, Image } from 'components';
import { Mail, Quote, Calendar } from 'icons';
import { staticURL } from 'core/url';

const incotermsDescription = {
  EXW: 'the customer is responsible for the collection of the goods.',
  FCA: 'the goods will be delivered to the agreed destination. Costs and duties related to import, insurance, loading, transportation as well as goods and services tax (such as VAT) may be applicable.',
  FAS: 'the goods will be delivered to the agreed ship. Costs and duties related to import, insurance, loading, freighting, delivery as well as goods and services tax (such as VAT) may be applicable.',
  FOB: 'the goods will be delivered to the agreed ship. Costs and duties related to import, insurance, freighting, delivery as well as goods and services tax (such as VAT) may be applicable.',
  CFR: 'the goods will be delivered to the agreed destination port. Costs and duties related to import, insurance, delivery as well as goods and services tax (such as VAT) may be applicable.',
  CIF: 'the goods will be delivered to the agreed destination port. Costs and duties related to import, delivery as well as goods and services tax (such as VAT) may be applicable.',
  CPT: 'costs and duties related to import, customs, insurance, delivery as well as goods and services tax (such as VAT) may be applicable.',
  CIP: 'costs and duties related to import, customs, delivery as well as goods and services tax (such as VAT) may be applicable.',
  DAT: 'costs and duties related to import, customs, delivery as well as goods and services tax (such as VAT) may be applicable.',
  DAP: 'costs and duties related to import, customs as well as goods and services tax (such as VAT) may be applicable.',
  DDP: 'transportation costs, taxes and other duties are already accounted for.',
  DDU: 'the goods will be delivered to the agreed destination. Delivery costs may be applicable.',
};

type INCOTERM = keyof typeof incotermsDescription;

interface TermsProps {
  quote: any;
}

export const Terms = ({ quote }: TermsProps) => {
  return (
    <Box>
      <Heading level={2} size='medium' margin='0 0 32px 0'>
        Terms
      </Heading>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <List
          sx={{ paddingLeft: 0, width: '50%' }}
          iconSize='medium'
          alignItems='flex-start'
        >
          <ListItem icon={<Mail />}>
            For any inquiries, please feel free to email
            marketplace@wikifactory.com.
          </ListItem>
          <ListItem icon={<Quote />}>
            The Shipping cost is quoted with the Incoterm {quote.incoterm}. This
            means {incotermsDescription[quote.incoterm as INCOTERM]}
          </ListItem>
          <ListItem icon={<Calendar />}>
            Your order will start being processed the next working day after
            payment is received.
          </ListItem>
        </List>
        <Image
          src={staticURL('assets/icons/shapes.svg')}
          sx={{
            width: 264,
            background: 'transparent',
          }}
          alt='Shapes'
        />
      </Box>
    </Box>
  );
};
